<template>
    <div id="addresses">
        <!-- <input ref="autocomplete"
        placeholder="Search"
        class="search-location"
        onfocus="value = ''"
        type="text" /> -->
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
                <v-flex xs12 lg6><v-text-field :disabled="disabled" autocomplete="nope" :id ="'data_input_ac_' + (componentId || '')" ref="auto" :label="addressText(1)" placeholder="Street Number and Name" v-model="placeDTO.formAddress" :rules="requiredRule"></v-text-field></v-flex>
                <v-flex xs12 lg6><v-text-field :disabled="disabled" autocomplete="nope" :label="addressText(2)" placeholder="Apt or Lot Number" v-model="placeDTO.formAddress2"></v-text-field></v-flex>
                <v-flex xs6 lg4><v-text-field :disabled="disabled" autocomplete="nope" label="City" placeholder=" " v-model="placeDTO.city" :rules="requiredRule"></v-text-field></v-flex>
                <v-flex xs6 lg2><v-autocomplete :disabled="disabled" autocomplete="nope" label="State" placeholder=" " :items="states" v-model="placeDTO.state" :rules="requiredRule"></v-autocomplete></v-flex>
                <v-flex xs6 lg2><v-text-field :disabled="disabled" autocomplete="nope" label="Zip Code" placeholder=" " v-model="placeDTO.zip" :rules="requiredRule"></v-text-field></v-flex>
                <v-flex xs6 lg4><v-text-field :disabled="disabled" autocomplete="nope" label="Country" placeholder=" " v-model="placeDTO.country"></v-text-field></v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
/*eslint-disable no-console*/
export default {
    props: ['isRequired', 'value', 'disabled', 'customAddressLabelPrepend', 'componentId'],
    data: function () {
        return {
            errors: [],
            placeDTO: {
                place: '',
                lat: '',
                lon: '',
                streetNumberObj: '',
                streetNameObj: '',
                cityObj: '',
                countyObj: '',
                stateObj: '',
                countryObj: '',
                zipObj: '',
                zipSuffixObj: '',
                formAddress: '',
                formAddress2: '',
                city: '',
                state: '',
                zip: '',
                country: 'United States',
                county: ''
            },
            states: [
                { text: 'AL', value: 'Alabama' },
                { text: 'AK', value: 'Alaska' },
                { text: 'AS', value: 'American Samoa' },
                { text: 'AZ', value: 'Arizona' },
                { text: 'AR', value: 'Arkansas' },
                { text: 'CA', value: 'California' },
                { text: 'CO', value: 'Colorado' },
                { text: 'CT', value: 'Connecticut' },
                { text: 'DE', value: 'Delaware' },
                { text: 'DC', value: 'District Of Columbia' },
                { text: 'FL', value: 'Florida' },
                { text: 'GA', value: 'Georgia' },
                { text: 'GU', value: 'Guam' },
                { text: 'HI', value: 'Hawaii' },
                { text: 'ID', value: 'Idaho' },
                { text: 'IL', value: 'Illinois' },
                { text: 'IN', value: 'Indiana' },
                { text: 'IA', value: 'Iowa' },
                { text: 'KS', value: 'Kansas' },
                { text: 'KY', value: 'Kentucky' },
                { text: 'LA', value: 'Louisiana' },
                { text: 'ME', value: 'Maine' },
                { text: 'MD', value: 'Maryland' },
                { text: 'MA', value: 'Massachusetts' },
                { text: 'MI', value: 'Michigan' },
                { text: 'MN', value: 'Minnesota' },
                { text: 'MS', value: 'Mississippi' },
                { text: 'MO', value: 'Missouri' },
                { text: 'MT', value: 'Montana' },
                { text: 'NE', value: 'Nebraska' },
                { text: 'NV', value: 'Nevada' },
                { text: 'NH', value: 'New Hampshire' },
                { text: 'NJ', value: 'New Jersey' },
                { text: 'NM', value: 'New Mexico' },
                { text: 'NY', value: 'New York' },
                { text: 'NC', value: 'North Carolina' },
                { text: 'ND', value: 'North Dakota' },
                { text: 'MP', value: 'Northern Mariana Islands' },
                { text: 'OH', value: 'Ohio' },
                { text: 'OK', value: 'Oklahoma' },
                { text: 'OR', value: 'Oregon' },
                { text: 'PA', value: 'Pennsylvania' },
                { text: 'PR', value: 'Puerto Rico' },
                { text: 'RI', value: 'Rhode Island' },
                { text: 'SC', value: 'South Carolina' },
                { text: 'SD', value: 'South Dakota' },
                { text: 'TN', value: 'Tennessee' },
                { text: 'TX', value: 'Texas' },
                { text: 'UT', value: 'Utah' },
                { text: 'VT', value: 'Vermont' },
                { text: 'VI', value: 'Virgin Islands' },
                { text: 'VA', value: 'Virginia' },
                { text: 'WA', value: 'Washington' },
                { text: 'WV', value: 'West Virginia' },
                { text: 'WI', value: 'Wisconsin' },
                { text: 'WY', value: 'Wyoming' },
                { text: '', value: '' }
            ]
        }
    },
    computed: {
        requiredRule () {
            return [v => {
                if (this.isRequired) return !!v || 'Required'
                else return true
            }]
        }
    },
    /*global google*/
    //line above IS absolutely necessary
    mounted () {
        var autocompleteInputId = '#data_input_ac_' + (this.componentId || '')
        var autocompleteInput = this.$el.querySelector(autocompleteInputId)

        //hack to stop google places api overwriting the autocompleteInput's autocomplete attribute to 'off'
        var observerHack = new MutationObserver(function () {
            observerHack.disconnect()
            document.getElementById(autocompleteInputId).setAttribute(autocompleteInputId, 'nope')
        })

        observerHack.observe(autocompleteInput, {
            attributes: true
        })
        //end hack

        this.autocomplete = new google.maps.places.Autocomplete(
        /** @type { !HTMLInputElement } */(autocompleteInput),
            { types: ['geocode'] }
        )
        this.autocomplete.setFields(['address_components', 'geometry'])

        this.autocomplete.addListener('place_changed', () => {
            this.placeDTO.place = this.autocomplete.getPlace()
            this.placeDTO.lat = this.placeDTO.place.geometry.location.lat()
            this.placeDTO.lon = this.placeDTO.place.geometry.location.lng()
            this.placeDTO.other = 'new text'
            this.placeDTO.streetNumberObj = this.placeDTO.place.address_components.find(function (e) { return e.types.includes('street_number') })
            this.placeDTO.streetNameObj = this.placeDTO.place.address_components.find(function (e) { return e.types.includes('route') })
            this.placeDTO.cityObj = (this.placeDTO.place.address_components.find(function (e) { return e.types.includes('locality') }) ||
                this.placeDTO.place.address_components.find(function (e) { return e.types.includes('sublocality') }))
            this.placeDTO.city = this.placeDTO.cityObj.short_name
            this.placeDTO.countyObj = this.placeDTO.place.address_components.find(function (e) { return e.types.includes('administrative_area_level_2') })
            this.placeDTO.stateObj = this.placeDTO.place.address_components.find(function (e) { return e.types.includes('administrative_area_level_1') })
            this.placeDTO.state = this.placeDTO.stateObj.long_name
            this.placeDTO.countryObj = this.placeDTO.place.address_components.find(function (e) { return e.types.includes('country') })
            this.placeDTO.country = this.placeDTO.countryObj.long_name
            this.placeDTO.zipObj = this.placeDTO.place.address_components.find(function (e) { return e.types.includes('postal_code') })
            this.placeDTO.zipSuffixObj = this.placeDTO.place.address_components.find(function (e) { return e.types.includes('postal_code_suffix') })
            this.placeDTO.zip = (this.placeDTO.zipObj) ? (this.placeDTO.zipSuffixObj) ? this.placeDTO.zipObj.short_name + '-' + this.placeDTO.zipSuffixObj.short_name : this.placeDTO.zipObj.short_name : ''
            this.placeDTO.formAddress = (this.placeDTO.streetNameObj) ? (this.placeDTO.streetNumberObj) ? this.placeDTO.streetNumberObj.short_name + ' ' + this.placeDTO.streetNameObj.short_name : this.placeDTO.streetNameObj.short_name : ''
            this.placeDTO.county = this.placeDTO.countyObj.long_name
        })
    },
    methods: {
        checkFields: function () {
            this.errors = []
            if (!this.placeDTO.formAddress || !this.placeDTO.city || !this.placeDTO.state || !this.placeDTO.zip) {
                this.errors.push('full address (including city, state, zip) is required')
            }
            return this.errors.length > 0
        },
        addressText (num) {
            return (this.customAddressLabelPrepend || '') + 'Address ' + num
        }
    }
}
</script>
